<script setup lang="ts">
import type { IHeaderNav } from "~/utils/interfaces/table-interfaces";
import type { PropType } from "vue";
import { TrainingNavEnum } from "~/utils/enums/training.enums";
import { useCreateTrainingStore } from "~/store/trainings/create-training.store";
import { storeToRefs } from "pinia";

defineProps({
  currNav: {
    type: Number,
  },
  headersNav: {
    type: Array as PropType<IHeaderNav[]>,
  },
  disabledNav: {
    type: Boolean,
    default: false,
  },
  progression: {
    type: Number,
    default: 0,
  },
  manualNav: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits(["update:currNav"]);

const createTrainingStore = useCreateTrainingStore();
const { training } = storeToRefs(createTrainingStore);

async function navigate(nav: TrainingNavEnum) {
  await createTrainingStore.validation();

  if (!Object.keys(training.value.errors).length) emit("update:currNav", nav);
}
</script>

<template>
  <header class="grid_nav" :class="!disabledNav ? 'border-nav' : ''">
    <div
      v-for="(nav, index) in headersNav"
      v-if="!disabledNav"
      :key="`key-${nav.name}`"
      class="grid_nav_button"
      :class="{ nav_selected: currNav === index, 'cursor-pointer': manualNav }"
      @click="manualNav && navigate(nav.nb as TrainingNavEnum)"
    >
      <span class="grid_nav_text body_regular">{{ nav.name }}</span>
    </div>

    <div v-else class="w-full flex">
      <div :style="{ width: `${progression}%` }" class="progression-bar"></div>
      <div :style="{ width: `${100 - progression}%` }" class="progression-bar end"></div>
    </div>
  </header>
  <div v-if="createTrainingStore.readonly" class="flex justify-center mt-[32px]">
    <div class="tooltip__container w-fit">
      <div class="py-[16px] px-[16px] items-center flex flex-row gap-[8px]">
        <img src="/icons/emojis/eyes.svg" alt="" :style="{ height: '16px', width: '16px' }" />
        <span class=""> Cette formation n’est pas modifiable car elle est issue du Répertoire Simbel </span>
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
.tooltip__container {
  @apply rounded-lg;
  background-color: var(--grey-light);
  border: 1px solid var(--grey-light);
  color: var(--text-secondary-color);
}
.grid_nav {
  @apply flex flex-row gap-[24px]  justify-between;
}
.border-nav {
  @apply border-b-[1px] border-stroke-color;
}

.grid_nav_button {
  @apply px-[8px] pb-[8px];
  border-bottom: 2px solid transparent;
  color: var(--text-secondary-color);
  width: 176px;
  text-align: center;
}

.grid_nav_text {
  text-align: center;
}

.nav_selected {
  @apply text-primary-blue-color;
  border-bottom: 2px solid var(--primary-blue-color);
}

.project__close_button {
  @apply absolute top-0 right-0;
  padding: 12px;

  img {
    width: 24px;
    height: 24px;
  }
}

.progression-bar {
  background-color: var(--primary-blue-color);
  height: 2px;
  &.end {
    background-color: var(--grey-lightest);
  }
}
</style>
